// Lista documenti (query plurale → il proxy senza ?raw=true restituisce un array piatto).
// org_pointer esteso con i campi località/stato dell'organizzazione.
export const queryAllDocs = `
  {
    org_docs(first: 10000) {
      edges {
        node {
          objectId
          nome_documento
          updatedAt
          createdAt
          generico
          precompilato
          template_type
          pdf_form { url }
          org_pointer {
            objectId
            nome
          }
        }
      }
    }
  }`;

// Coordinate org per il join (query plurale → array piatto senza ?raw=true).
export const orgCoordsQuery = `
  {
    org_coords(first: 10000) {
      edges {
        node {
          objectId
          latitude
          longitude
          org_pointer { objectId }
        }
      }
    }
  }`;

// Full-text server-side sul contenuto HTML. Restituisce solo gli objectId.
export const queryDocsByContent = `
  query DocsByContent($term: String!) {
    org_docs(first: 10000, where: { documento: { matchesRegex: $term, options: "i" } }) {
      edges { node { objectId } }
    }
  }`;

// Documento con sorgente HTML per il drawer (query singola → il proxy restituisce l'oggetto).
export const querySingleDocFull = `
  query getFullDoc($id: ID!) {
    org_doc(id: $id) {
      objectId
      nome_documento
      documento
    }
  }`;

// Documenti di una singola org (query plurale → array piatto senza ?raw=true).
// Stessi campi di queryAllDocs ma filtrati per org_pointer; niente org_pointer annidato
// (la org è nota dal contesto). updatedAt/template_type servono a ordinamento e card.
export const queryDocsByOrg = `
  query DocsByOrg($where: Org_docWhereInput) {
    org_docs(first: 10000, where: $where) {
      edges {
        node {
          objectId
          nome_documento
          updatedAt
          createdAt
          generico
          precompilato
          template_type
          pdf_form { url }
        }
      }
    }
  }`;

// Elimina un documento (spostata qui da OrgDocumenti.js).
export const mutationDeleteOrgDoc = `
  mutation DeleteDocument($id: ID!) {
    deleteOrg_doc(input: { id: $id }) {
      org_doc { objectId }
    }
  }`;
